import { LitElement, html, unsafeCSS, type CSSResultGroup } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'
import { $t, localized } from '@/navbar/i18n'
import type { EcoSuiteNavbarButton } from '../button/eco-suite-navbar-button.component'

// Styles:
import styles from './eco-suite-navbar-side-menu-button.scss?inline'

// Child components:
import '../button/eco-suite-navbar-button.component'

/** @internal */
@localized()
@customElement('eco-suite-navbar-side-menu-button')
export class EcoSuiteNavbarSideMenuButton extends LitElement {
  static readonly shadowRootOptions = { ...LitElement.shadowRootOptions, delegatesFocus: true }
  static readonly styles: CSSResultGroup = [unsafeCSS(styles)]

  @query('eco-suite-navbar-button')
  private readonly button!: EcoSuiteNavbarButton

  @property({ attribute: false })
  onToggle?: () => void

  @property({ attribute: false })
  isActive = false

  public click() {
    this.button.click()
  }

  render() {
    return html`
      <div class=${`SideMenuButton ${this.isActive ? 'SideMenuButton--active' : ''}`}>
        <eco-suite-navbar-button
          .forceNavbarContext=${'desktop'}
          label=${this.isActive ? $t('navbar.closeSideNav') : $t('navbar.openSideNav')}
          @click=${this.onToggle}
        >
          <div slot="icon" class="iconContainer">
            <pwc-icon-shadow icon="cross" size="sm"></pwc-icon-shadow>
            <pwc-icon-shadow icon="nav-menu" size="sm"></pwc-icon-shadow>
          </div>
        </eco-suite-navbar-button>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'eco-suite-navbar-side-menu-button': EcoSuiteNavbarSideMenuButton
  }
}
